export const translations = {
  en: {
    hero: {
      title: "Software Engineer",
      location: "31/01/1994, Madrid (SPAIN)",
      description: "Building innovative digital solutions with passion for excellence and cutting-edge technology",
    },
    about: {
      title: "About Me",
      description:
        "Software engineer specialized in multiplatform application development. Experience with hexagonal architecture, AI development and portfolio management. Passionate about technical excellence, clean code and SOLID principles.",
    },
    education: {
      title: "Education",
      courses: {
        multiplatform: "Multiplatform Application Soft. Development",
        master: "Master in Software Engineering",
        bootcamp: "Full Stack Bootcamp",
      },
      institutions: {
        thePower: "The Power, Madrid",
        techUniversity: "Tech University, Madrid",
        neoland: "Neoland, Madrid",
      },
    },
    experience: {
      title: "Professional Experience",
      current: "Current",
      jobs: {
        softwareEngineer: {
          title: "Founding Software Engineer",
          company: "Aurelia Intelligence",
          period: "Oct - Current",
          description:
            "Founding Software Engineer at Aurelia Intelligence, focused on building and scaling an AI-native product for private equity workflows.",
          tasks: [
            "Infrastructure on AWS: cloud architecture, environment setup, and GDPR-compliant deployments.",
            "AWS operations: provisioning, maintenance, and reliability improvements across production infrastructure.",
            "Architecture and models: architecture decisions and model selection based on use case, cost, and compliance.",
            "AI tooling: design and integration of RAG, inbound email processing, document generation, and other agentic capabilities.",
            "Prompt engineering: continuous design, evaluation, and optimization of prompts.",
            "Performance and cost: reduce latency and inference cost.",
            "Quality and observability: E2E tests, CI/CD, structured logging, and AI pipeline traceability.",
            "Security: secrets management, access control, and hardening.",
            "Data: modeling, migrations, and data integrity.",
            "DevEx: internal tooling and templates to accelerate the team.",
            "Technical leadership: code reviews, onboarding, and standards definition.",
            "Client discovery: translate PE fund needs into technical solutions.",
            "Product: build new cross-stack features and fix bugs.",
          ],
        },
        middleDev: {
          title: "Middle Soft. Developer",
          company: "Cognodata",
          period: "Sept 24 - Oct 25",
          description:
            "Development of software modules for the implementation of Text To Speech functionality in ATM machines to comply with EU regulations. Clients: ING, Abanca, CECA",
        },
        fullStack: {
          title: "Full Stack Developer",
          company: "Freelance",
          period: "Mar 22 - Sept 25",
          tasks: [
            "Development of mobile and web applications for remote management, telemetry reading and scheduler of smart streetlights and greenhouses.",
            "Development of PDF report and graph generator module from an online questionnaire. Implementation of end-to-end tests.",
            "Deployment of apps in marketplaces",
          ],
        },
      },
    },
    skills: {
      title: "Tech Stack",
      frontend: "Frontend",
      backend: "Backend",
      databases: "Databases",
      testing: "Testing",
      devops: "DevOps",
    },
    softSkills: {
      title: "Tech & Soft Skills",
      items: {
        solid: "SOLID & Design Patterns",
        tdd: "Test Driven Development",
        specdd: "Spec Driven Development",
        agent: "AI Development & Agent Orchestration",
        problemSolving: "Problem Solving",
        mentoring: "Mentoring Developers",
      },
    },
    languages: {
      title: "Languages",
      spanish: "Spanish",
      english: "English",
      german: "German",
      native: "Native",
    },
    clients: {
      title: "Clients",
    },
    contact: {
      title: "Contact",
      subtitle: "Interested in working together? Let's connect!",
    },
    footer: {
      rights: "All rights reserved.",
    },
    portfolio: {
      title: "Featured Project",
      viewRepo: "View on GitHub",
      viewRelease: "View Release",
      nidoApp: {
        name: "NIDO_APP",
        tagline: "Home coordination for groups that live together",
        description:
          "A full-stack mobile application built with React Native + Expo that helps groups of people living together manage shared expenses, tasks, notes, events, and more. Built with Clean Architecture and enterprise-grade patterns.",
        architecture: "Clean Architecture (Controller → Service → Repository → MongoDB)",
        release: "Released v1.0.0 - May 2026",
        features: {
          expenses: "Shared expenses with automatic balance calculation",
          tasks: "Tasks organized by color-coded groups",
          notes: "Collaborative notes with full-text search",
          events: "Group calendar with events",
          admin: "Admin panel with roles (owner/admin/member)",
        },
      },
    },
  },
  es: {
    hero: {
      title: "Ingeniero de Software",
      location: "31/01/1994, Madrid (ESPAÑA)",
      description:
        "Construyendo soluciones digitales innovadoras con pasión por la excelencia y la tecnología de vanguardia",
    },
    about: {
      title: "Sobre mí",
      description:
        "Ingeniero de software especializado en el desarrollo de aplicaciones multiplataforma. Experiencia con arquitectura hexagonal, desarrollo de IA y gestión de portafolios. Apasionado por la excelencia técnica, el código limpio y los principios SOLID.",
    },
    education: {
      title: "Formación Académica",
      courses: {
        multiplatform: "Desarrollo de Aplicaciones Multiplataforma",
        master: "Máster en Ingeniería de Software",
        bootcamp: "Bootcamp Full Stack",
      },
      institutions: {
        thePower: "The Power, Madrid",
        techUniversity: "Universidad Tecnológica, Madrid",
        neoland: "Neoland, Madrid",
      },
    },
    experience: {
      title: "Experiencia Profesional",
      current: "Actualmente",
      jobs: {
        softwareEngineer: {
          title: "Founding Software Engineer",
          company: "Aurelia Intelligence",
          period: "Oct - Actualmente",
          description:
            "Founding Software Engineer en Aurelia Intelligence, enfocado en construir y escalar un producto AI-native para flujos de trabajo de private equity.",
          tasks: [
            "Infraestructura en AWS: arquitectura cloud, configuración de entornos y despliegues con cumplimiento GDPR.",
            "Gestión de infraestructura AWS: aprovisionamiento, mantenimiento y mejoras de fiabilidad en producción.",
            "Arquitectura y modelos: decisiones de arquitectura y selección de modelos según caso de uso, coste y cumplimiento.",
            "Herramientas de IA: diseño e integración de RAG, email inbound, generación documental y otras capacidades agénticas.",
            "Prompt engineering: diseño, evaluación y optimización continua de prompts.",
            "Rendimiento y coste: reducción de latencia y coste por inferencia.",
            "Calidad y observabilidad: tests E2E, CI/CD, logging estructurado y trazabilidad de pipelines de IA.",
            "Seguridad: gestión de secretos, control de accesos y hardening.",
            "Datos: modelado, migraciones e integridad.",
            "DevEx: tooling interno y plantillas para acelerar al equipo.",
            "Liderazgo técnico: code reviews, onboarding y definición de estándares.",
            "Discovery con cliente: traducir necesidades de fondos PE a soluciones técnicas.",
            "Producto: desarrollo de nuevas funcionalidades cross-stack y resolución de bugs.",
          ],
        },
        middleDev: {
          title: "Desarrollador Software Medio",
          company: "Cognodata",
          period: "Sept 24 - Oct 25",
          description:
            "Desarrollo de módulos de software para la implementación de funcionalidad Text To Speech en cajeros automáticos para cumplir con las regulaciones de la UE. Clientes: ING, Abanca, CECA",
        },
        fullStack: {
          title: "Desarrollador Full Stack",
          company: "Freelance",
          period: "Mar 22 - Sept 25",
          tasks: [
            "Desarrollo de aplicaciones móviles y web para gestión remota, lectura de telemetría y programador de farolas inteligentes e invernaderos.",
            "Desarrollo de módulo generador de informes PDF y gráficos desde un cuestionario online. Implementación de tests end-to-end.",
            "Despliegue de aplicaciones en marketplaces",
          ],
        },
      },
    },
    skills: {
      title: "Stack Tecnológico",
      frontend: "Frontend",
      backend: "Backend",
      databases: "Bases de Datos",
      testing: "Testing",
      devops: "DevOps",
    },
    softSkills: {
      title: "Habilidades Técnicas y Blandas",
      items: {
        solid: "SOLID y Patrones de Diseño",
        tdd: "Desarrollo Dirigido por Pruebas",
        specdd: "Desarrollo Dirigido por especificaciones",
        agent: "Desarrollo con IA y orquestación de Agentes",
        problemSolving: "Resolución de Problemas",
        mentoring: "Mentoría de Desarrolladores",
      },
    },
    languages: {
      title: "Idiomas",
      spanish: "Español",
      english: "Inglés",
      german: "Alemán",
      native: "Nativo",
    },
    clients: {
      title: "Clientes",
    },
    contact: {
      title: "Contacto",
      subtitle: "¿Interesado en trabajar juntos? ¡Conectemos!",
    },
    footer: {
      rights: "Todos los derechos reservados.",
    },
    portfolio: {
      title: "Proyecto Destacado",
      viewRepo: "Ver en GitHub",
      viewRelease: "Ver Release",
      nidoApp: {
        name: "NIDO_APP",
        tagline: "Coordinación del hogar para grupos que viven juntos",
        description:
          "Aplicación móvil full-stack construida con React Native + Expo que ayuda a grupos de personas que viven juntas a gestionar gastos compartidos, tareas, notas, eventos y más. Construida con Clean Architecture y patrones de nivel empresarial.",
        architecture: "Clean Architecture (Controller → Service → Repository → MongoDB)",
        release: "Lanzada v1.0.0 - Mayo 2026",
        features: {
          expenses: "Gastos compartidos con cálculo automático de balances",
          tasks: "Tareas organizadas por grupos de color",
          notes: "Notas colaborativas con búsqueda de texto completo",
          events: "Calendario de grupo con eventos",
          admin: "Panel de admin con roles (owner/admin/member)",
        },
      },
    },
  },
};
